/**
 * AddBlockButton — `+` button to append a new empty block at the bottom of a
 * Video or Audio track column.
 */

import { memo } from 'react'

interface AddBlockButtonProps {
  track: 'video' | 'audio'
  onClick: () => void
}

export const AddBlockButton = memo(function AddBlockButton({
  track,
  onClick,
}: AddBlockButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full flex items-center justify-center gap-1 py-1 text-xxs uppercase tracking-wider text-text-muted hover:text-primary border border-dashed border-border-subtle hover:border-primary/40 rounded transition-colors"
      data-testid={`add-block-${track}`}
    >
      <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 4v16m8-8H4"
        />
      </svg>
      Add {track === 'video' ? 'video' : 'audio'} block
    </button>
  )
})
